import LandingPage from 'pages/UniversalProductsPage/LandingPage/LandingPage';
export default LandingPage;
